<template>
    <div class="request-messages">
        <b-button v-if="!expanded" variant="info" v-b-modal="'messages_'+_uid" size="sm">
            <font-awesome-icon icon="envelope" />
        </b-button>
        <b-modal :id="'messages_'+_uid" :title="'Messaggi R-' + request_id" size="xl" hide-footer
            @show="() => {
                get_messages_from_api()
            }">
            <b-spinner v-if="loading"></b-spinner>
            <div class="request-messages--modal" v-if="!loading">
                <div class="request-messages--new">

                    <b-row>
                        <b-col md="8" offset-md="2">
                            <tiny-mce
                                :height="400"
                                :initial_value="new_message"
                                @input="(value) => {
                                    this.new_message = value
                                }"
                            />                            
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col md="8" offset-md="2">
                            <b-form-checkbox
                                id="email_notification"
                                v-model="email_notification"
                                name="email_notification"
                                class="mt-2 mb-2"
                                >
                                Invia per email all'utente <b>(valido solo per messaggi pubblici)</b>
                            </b-form-checkbox>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col class="request-messages--buttons mt-2 mb-4">
                            <div class="request-messages--button">
                                <b-button size="sm" variant="success" :disabled="new_message.length < 4"
                                    @click="() => {
                                        post_message_to_api(false, this.new_message)
                                        this.new_message = ''
                                    }"
                                >invia messaggio pubblico</b-button>
                            </div>
                            <div class="request-messages--button">
                                <b-button size="sm" variant="danger" :disabled="new_message.length < 4"
                                    @click="() => {
                                        post_message_to_api(true,this.new_message)
                                        this.new_message = ''
                                    }"
                                >invia messaggio privato</b-button>
                            </div>
                        </b-col>
                    </b-row>
                </div>
                <table v-if="messages.length > 0">
                    <thead>
                        <tr>
                            <td>
                                data
                            </td>
                            <td>
                                messaggio
                            </td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="request-messages--message" v-for="(message,index) in messages" v-bind:key="index">
                            <td>
                                <div class="request-messages--date">
                                  {{message.created_at | moment("DD-MM-YYYY HH:mm") }}
                                </div>
                            </td>
                            <td>
                                <div class="request-messages--from">
                                    <i><span v-html="message.banconiste_id == 1 ? 'cliente' : banconiste.filter(function(b){ return b.banconiste_id == message.banconiste_id })[0].display_name"></span><span v-if="message.is_private"> (privato)</span></i>
                                </div>
                                <div class="request-messages--body" v-html="message.messaggio"></div>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <span v-else>nessun messaggio</span>
            </div>
        </b-modal>

        <div v-if="expanded">
            <div class="request-messages-preview--heading">
                <label>
                    <span>Ultimi messaggi</span>
                    <font-awesome-icon icon="pencil-alt" v-b-modal="'messages_'+_uid" />
                </label>
                <!--<font-awesome-icon icon="pencil-alt" v-b-modal="'messages_'+_uid" />-->
                <small v-if="messages.length == 0"><i>Non ci sono ancora note interne per questa proposta</i></small>
            </div>
            <div v-if="messages.length > 0">
                <table v-if="messages.length > 0" class="request-messages-preview--table">
                    <!--
                    <thead>
                        <tr>
                            <td>
                                da
                            </td>
                            <td>
                                data
                            </td>
                            <td>
                                messaggio
                            </td>
                        </tr>
                    </thead>
                    -->
                    <tbody>
                        <tr class="request-messages--message" v-for="(message,index) in messages.slice(0, 5)" v-bind:key="index">
                            <td>
                                <div class="request-messages--from">
                                    <i><span v-html="message.banconiste_id == 1 ? 'cliente' : banconiste.filter(function(b){ return b.banconiste_id == message.banconiste_id })[0].display_name"></span></i>
                                </div>
                            </td>
                            <td>
                                <div class="request-messages--date">
                                  {{message.created_at | moment("DD-MM-YYYY HH:mm") }}
                                </div>
                            </td>
                            <td>
                                <div class="request-messages--body" v-html="(message.is_private == 1)? message.messaggio + ' (privato)' : message.messaggio"></div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    import TinyMce from "@/components/blocks/tiny-mce"
    import { get_messages, post_message } from '@/api/'

    export default {
        name: 'request-messages',
        components: {
            'tiny-mce': TinyMce,
        },
        props: {
            request_id: String,
            expanded: {
                type: Boolean,
                default: false,
            }
        },
        created() {
            this.get_messages = get_messages
            this.post_message = post_message
        },
        data() {
            return {
                banconiste: Vue.prototype.$config.banconiste,
                messages: [],
                loading: true,
                new_message: '',
                email_notification: true
            }
        },
        mounted() {
            if (this.expanded) this.get_messages_from_api()
        },
        methods:
        {
            get_messages_from_api(){
                this.loading = true
                get_messages({
                    request_id: this.request_id
                })
                .then((response)=>{
                    this.messages = response.reverse()
                    this.loading = false
                })
            },
            post_message_to_api(is_private,message){
                this.loading = true
                post_message({
                    request_id: this.request_id,
                    is_private: is_private,
                    messaggio: message,
                    email_notification: (!is_private && this.email_notification)? true : false
                })
                .then((response)=>{
                    (response)
                    this.get_messages_from_api()
                })
            },
        }
    }
</script>

<style lang="scss">
    // spostato in _messages.scss
</style>